import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';
import { PessoaDTO } from '../../../../../models/clientes/pessoa.model';
import { PessoaService } from '../../../../../services/pessoas/pessoas.service';

@Component({
  selector: 'app-pessoas-card',
  templateUrl: './pessoas-card.component.html',
  styleUrls: ['./pessoas-card.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class PessoasCardComponent implements OnInit, OnDestroy {
  @Input() pessoaId: number | undefined;
  pessoa: PessoaDTO = {} as PessoaDTO;
  pessoaValores: any;
  @Input() IsFornecedor: boolean = false;
  @Input() IsCliente: boolean = false;

  // Objetos de traducao
  texts = {
    titulo: '',
    quantidade_vendas: '',
    total_vendas: '',
    quantidade_compras: '',
    total_compras: '',
    informacoes_contato: '',
    endereco: '',
    estado: '',
    cidade: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private pessoaService: PessoaService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });

    if (this.pessoaId === undefined) return;
    await this.findPessoaValores();
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private loadTranslations(): void {
    this.texts = {
      titulo: this.translate.instant('shared.pessoas-card.titulo'),
      quantidade_vendas: this.translate.instant('shared.pessoas-card.quantidade_vendas'),
      total_vendas: this.translate.instant('shared.pessoas-card.total_vendas'),
      quantidade_compras: this.translate.instant('shared.pessoas-card.quantidade_compras'),
      total_compras: this.translate.instant('shared.pessoas-card.total_compras'),
      informacoes_contato: this.translate.instant('shared.pessoas-card.informacoes_contato'),
      endereco: this.translate.instant('shared.pessoas-card.endereco'),
      estado: this.translate.instant('shared.pessoas-card.estado'),
      cidade: this.translate.instant('shared.pessoas-card.cidade')
    };
  }

  findPessoaValores(): Promise<void> {
    return new Promise((resolve) => {
      this.pessoaService
        .getPessoasValores(
          `/pessoas/listarValoresTotaisPessoa?pessoaId=${this.pessoaId}`
        )
        .subscribe((response) => {
          this.pessoaValores = response[0];
          this.pessoa = response[0].pessoaDTO;
          resolve();
        });
    });
  }
}
